export default __webpack_public_path__ + "static/media/undraw_Code_thinking_re_gka2.27a0794b.svg";